import { fontStyles } from '../../theme/fonts'

// serifTitle
export const serifTitle58 = {
  ...fontStyles.serifTitle,
  fontSize: 58,
  lineHeight: '60px'
}
export const serifTitle38 = {
  ...fontStyles.serifTitle,
  fontSize: 38,
  lineHeight: '43px'
}
export const serifTitle32 = {
  ...fontStyles.serifTitle,
  fontSize: 32,
  lineHeight: '34px'
}
export const serifTitle30 = {
  ...fontStyles.serifTitle,
  fontSize: 30,
  lineHeight: '34px'
}
export const serifTitle28 = {
  ...fontStyles.serifTitle,
  fontSize: 28,
  lineHeight: '30px'
}
export const serifTitle26 = {
  ...fontStyles.serifTitle,
  fontSize: 26,
  lineHeight: '28px'
}
export const serifTitle22 = {
  ...fontStyles.serifTitle,
  fontSize: 22,
  lineHeight: '24px'
}
export const serifTitle20 = {
  ...fontStyles.serifTitle,
  fontSize: 20,
  lineHeight: '22px'
}
export const serifTitle16 = {
  ...fontStyles.serifTitle,
  fontSize: 16,
  lineHeight: '18px'
}

// serifRegular
export const serifRegular25 = {
  ...fontStyles.serifRegular,
  fontSize: 25,
  lineHeight: '33px'
}
export const serifRegular23 = {
  ...fontStyles.serifRegular,
  fontSize: 23,
  lineHeight: '30px'
}
export const serifRegular21 = {
  ...fontStyles.serifRegular,
  fontSize: 21,
  lineHeight: '32px'
}
export const serifRegular19 = {
  ...fontStyles.serifRegular,
  fontSize: 19,
  lineHeight: '30px'
}
export const serifRegular18 = {
  ...fontStyles.serifRegular,
  fontSize: 18,
  lineHeight: '24px'
}
export const serifRegular17 = {
  ...fontStyles.serifRegular,
  fontSize: 17,
  lineHeight: '26px'
}
export const serifRegular16 = {
  ...fontStyles.serifRegular,
  fontSize: 16,
  lineHeight: '24px'
}
export const serifRegular15 = {
  ...fontStyles.serifRegular,
  fontSize: 15,
  lineHeight: '24px'
}

export const serifRegular14 = {
  ...fontStyles.serifRegular,
  fontSize: 14,
  lineHeight: '19px'
}

// serifBold
export const serifBold52 = {
  ...fontStyles.serifBold,
  fontSize: 52,
  lineHeight: '56px',
  letterSpacing: -0.45
}
export const serifBold42 = {
  ...fontStyles.serifBold,
  fontSize: 42,
  lineHeight: '48px',
  letterSpacing: -0.3
}
export const serifBold32 = {
  ...fontStyles.serifBold,
  fontSize: 32,
  lineHeight: 1.2
}
export const serifBold36 = {
  ...fontStyles.serifBold,
  fontSize: 36,
  lineHeight: '38px',
  letterSpacing: -0.3
}
export const serifBold28 = {
  ...fontStyles.serifBold,
  fontSize: 28,
  lineHeight: '33px'
}
export const serifBold24 = {
  ...fontStyles.serifBold,
  fontSize: 24,
  lineHeight: '30px',
  letterSpacing: -0.21
}
export const serifBold19 = {
  ...fontStyles.serifBold,
  fontSize: 19,
  lineHeight: '24px'
}
export const serifBold17 = {
  ...fontStyles.serifBold,
  fontSize: 17,
  lineHeight: '26px'
}
export const serifBold16 = {
  ...fontStyles.serifBold,
  fontSize: 16,
  lineHeight: '24px'
}

// sansSerifRegular

export const sansSerifRegular30 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 30,
  lineHeight: '35px'
}
export const sansSerifRegular23 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 23,
  lineHeight: '30px'
}
export const sansSerifRegular22 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 22,
  lineHeight: '26px'
}
export const sansSerifRegular21 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 21,
  lineHeight: '32px'
}
export const sansSerifRegular19 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 19,
  lineHeight: '30px'
}
export const sansSerifRegular18 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 18,
  lineHeight: '30px'
}
export const sansSerifRegular17 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 17,
  lineHeight: '26px'
}
export const sansSerifRegular16 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 16,
  lineHeight: '25px'
}
export const sansSerifRegular15 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 15,
  lineHeight: '21px'
}
export const sansSerifRegular14 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 14,
  lineHeight: '17px'
}
export const sansSerifRegular13 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 13,
  lineHeight: '16px'
}
export const sansSerifRegular12 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 12,
  lineHeight: '15px'
}
export const sansSerifRegular11 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 11,
  lineHeight: '12px'
}
export const sansSerifRegular10 = {
  ...fontStyles.sansSerifRegular,
  fontSize: 10,
  lineHeight: '12px'
}

// sansSerifMedium
export const sansSerifMedium58 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 58,
  lineHeight: '60px'
}
export const sansSerifMedium40 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 40,
  lineHeight: '46px',
  letterSpacing: -0.35
}
export const sansSerifMedium32 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 32,
  lineHeight: '34px'
}
export const sansSerifMedium30 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 30,
  lineHeight: '34px'
}
export const sansSerifMedium26 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 26,
  lineHeight: '28px'
}
export const sansSerifMedium24 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 24,
  lineHeight: '30px'
}
export const sansSerifMedium22 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 22,
  lineHeight: '28px',
  letterSpacing: 'normal'
}
export const sansSerifMedium20 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 20,
  lineHeight: '24px',
  letterSpacing: 'normal'
}
export const sansSerifMedium19 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 19,
  lineHeight: '30px'
}
export const sansSerifMedium18 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 18,
  lineHeight: '24px'
}
export const sansSerifMedium16 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 16,
  lineHeight: '25px'
}
export const sansSerifMedium15 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 15,
  lineHeight: '24px'
}
export const sansSerifMedium14 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 14,
  lineHeight: '17px'
}

export const sansSerifMedium12 = {
  ...fontStyles.sansSerifMedium,
  fontSize: 12,
  lineHeight: '15px'
}

// cursiveTitle
export const cursiveTitle58 = {
  ...fontStyles.cursiveTitle,
  fontSize: 58,
  lineHeight: '60px'
}
export const cursiveTitle32 = {
  ...fontStyles.cursiveTitle,
  fontSize: 32,
  lineHeight: '34px'
}
export const cursiveTitle30 = {
  ...fontStyles.cursiveTitle,
  fontSize: 30,
  lineHeight: '34px'
}
export const cursiveTitle26 = {
  ...fontStyles.cursiveTitle,
  fontSize: 26,
  lineHeight: '28px'
}
export const cursiveTitle22 = {
  ...fontStyles.cursiveTitle,
  fontSize: 22,
  lineHeight: '24px'
}
export const cursiveTitle20 = {
  ...fontStyles.cursiveTitle,
  fontSize: 20,
  lineHeight: '22px'
}
